<template lang="pug">
div
  el-table.jy-table(:data="showList", border)
    el-table-column(width="49", align="center", v-if="showSelection", key="selection")
      template(#header)
        bulk-checked(:list="showList", idKey="fileId", v-model="checkedIds") &nbsp;
      template(v-slot="{ row }")
        el-checkbox(:label="row.fileId", v-model="checkedIds") &nbsp;
    el-table-column(type="index", label="序号", align="center", width="60")
    el-table-column(v-slot="{ row, $index }", width="250", label="文件名", show-overflow-tooltip)
      .folder-name
        FileIcon(:row="fileList[$index]", @updateLight="updateLight")
        span.file-name-label(:class="{ 'target-err': !row.targetFolderPath }", @click="previewFn(row)") {{ row.fileName }}
    el-table-column(v-slot="{ row }", width="100", label="大小") {{ row.fileSize | fileSize }}
    el-table-column(label="文件路径", show-overflow-tooltip, prop="filePath")
    el-table-column(label="操作", align="center", v-slot="scoped")
      i.file-btn.el-icon-download(v-if="scoped.row.$url", @click.stop="downloadHandler(scoped.row)")
      i.file-btn.el-icon-delete(v-if="scoped.row.$delete", @click.stop="deleteFile(scoped.row, showList)")
      slot(name="btns", v-bind="scoped")
    el-table-column(label="创建人", align="center", prop="checkInUser", show-overflow-tooltip)
    el-table-column(label="创建时间", prop="checkInDate", show-overflow-tooltip)
    slot/
</template>
<script>
import FileIcon from "./FileIcon.vue";
import BulkChecked from "@/CommonDP/components/BulkChecked/index.vue";
import { downloadFile, downloadUrltoken } from "@/CommonDP/utils";
import { mapState } from "vuex";
import FileList from "./index.vue";
import docService from "@/CommonDP/service/doc-service.js";
import { filePreviewV1 } from "@/CommonDP/utils/docPublic";
export default {
  components: { BulkChecked, FileIcon },
  extends: FileList,
  props: {
    delete: { default: false, type: Boolean },
    showSelection: { default: false, type: Boolean },
    prjId: { default: "", type: String },
    preview: { default: undefined, type: [Function, undefined] },
    download: { default: undefined, type: [Function, undefined] }
  },
  data() {
    return {
      checkedIds: []
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    showList() {
      const list = this.fileList || [];
      return list.map((f) => ({
        ...f,
        folderId: f.fileId,
        $url: downloadUrltoken(f.prjId, f.fileId, f.version),
        $delete: this.delete
      }));
    }
  },
  methods: {
    updateLight(...arg) {
      this.$emit("updateLight", ...arg);
    },
    async downloadHandler(...args) {
      if (this.download) return this.download(...args);
      const { $url, folderId, version } = args[0];
      await docService.verifyFileIsDelete(folderId, version);
      downloadFile($url);
    },
    previewFn(...arg) {
      if (this.preview) {
        this.preview(...arg);
      } else {
        const { status, fileId, fileVersion: versionId = 1, parentId, fileType } = arg;
        const data = { status, fileId, versionId, parentId, fileType };
        filePreviewV1(data, this.showList);
      }
    },
    async deleteBatch() {
      const { fileList, checkedIds } = this;
      if (checkedIds.length === 0) {
        this.$message.warning("请选中文件后点击删除");
        return;
      }
      const surplus = fileList.filter(({ fileId }) => checkedIds.indexOf(fileId) === -1);
      await this.$confirm("确定删除选中?", "警告");
      const lostList = fileList.splice(0, fileList.length, ...surplus);
      this.checkedIds = [];
      for (const file of lostList) {
        this.$emit("delete", file);
      }
    },
    async deleteFile(file, list) {
      const index = list.indexOf(file);
      await this.$confirm("确定删除?", "警告");
      this.fileList.splice(index, 1);
      this.$emit("delete", this.fileList[index]);
    }
  }
};
</script>
<style lang="scss" scoped src="./index.scss"></style>
